export const DEFAULT_PROMOTION = {
    discount: null,
    discountPercentage: 15,
    title: 'Oferta de temporada',
    description: 'Reserva ahora y obtén un descuento especial en tu próxima estancia.',
    addedValueTitle: null,
    addedValueDescription: null,
    code: 'PLAYGROUND15',
    rollingEBBSettings: [],
    nightFree: null,
    secondNightFree: null,
    kidsFree: null,
    kidsFreeMax: null,
    isTwoForOne: null,
    isNightFree: null,
    travelWindowPeriods: [],
};
export const DEFAULT_CONTENT = {
    title: 'Oferta de temporada',
    description: 'Reserva ahora y obtén un descuento especial en tu próxima estancia.',
    buttonText: 'Reservar ahora',
    buttonUrl: '#',
};
export const TRIGGER_DEFAULTS = {
    inactivitySeconds: 5,
    scrollPercentage: 50,
    afterTimeElapsedSeconds: 5,
    autoHideSeconds: 5,
};
export const SHOW_AFTER_TIME_DEFAULTS = {
    frequencyUnitType: 'MINUTE',
    showEveryInterval: 1,
};
export function buildDesign(overrides = {}) {
    return Object.assign({ displayPositionType: 'CENTER', layout: 'MID', textStyle: [], heightType: 'AUTO' }, overrides);
}
export function buildConfiguration(overrides) {
    return {
        triggers: Object.assign({ afterTimeElapsed: { enabled: false, seconds: 0 }, exitIntent: false, inactivity: { enabled: false, seconds: 0 }, scroll: { enabled: false, percentage: 0 }, autoHide: { enabled: false, seconds: 0 } }, overrides.triggers),
        frequency: Object.assign({ frequencyType: 'SHOW_ONCE', frequencyUnitType: 'DAY', showEveryInterval: 1 }, overrides.frequency),
    };
}
export function getTriggerDescription(configuration) {
    if (!configuration) {
        return null;
    }
    const triggers = [];
    if (configuration.triggers.exitIntent) {
        triggers.push('EXIT_INTENT');
    }
    if (configuration.triggers.inactivity.enabled) {
        triggers.push(`INACTIVITY - ${configuration.triggers.inactivity.seconds}s`);
    }
    if (configuration.triggers.scroll.enabled) {
        triggers.push(`SCROLL - ${configuration.triggers.scroll.percentage}%`);
    }
    if (configuration.triggers.afterTimeElapsed.enabled) {
        triggers.push(`AFTER_TIME - ${configuration.triggers.afterTimeElapsed.seconds}s`);
    }
    if (configuration.triggers.autoHide.enabled) {
        triggers.push(`AUTO_HIDE - ${configuration.triggers.autoHide.seconds}s`);
    }
    return triggers.join(', ') || 'sin triggers';
}
export function buildPlaygroundPopup(overrides) {
    return Object.assign({ presentationType: 'POPUP', popupPhoto: {
            id: 1,
            basePath: 'https://res.cloudinary.com/itermotus/',
            path: 'hotel-stage/ixtul/5/09ddfa73-6-Eo-nTbPXUAMDmym.jpeg'
        }, configuration: null, design: buildDesign(), content: DEFAULT_CONTENT, promotion: DEFAULT_PROMOTION, utm: null, isMobile: false }, overrides);
}
